import { ConfirmModal } from '@base-app';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DeleteUserModalProps } from './DeleteUserModal.types';

const DeleteUserModal: FC<DeleteUserModalProps> = ({ onCancel, onConfirm, show, selectedUserId }) => {
  const { t } = useTranslation(['teams', 'common']);
  return (
    <ConfirmModal
      cancelAction={{
        onClick: onCancel,
        text: t('modal_cancel', { ns: 'common' }),
      }}
      data={selectedUserId}
      confirmAction={{
        onClick: onConfirm,
        text: t('delete_modal_confirmation'),
      }}
      show={show}
      title={t('delete_modal_title')}
    />
  );
};

export default DeleteUserModal;
